const sessionKey = 'paymentButtonAttachment';

module.exports = class {
    static get defaultValues() {
        return {
            retry: false,
        };
    }

    static get rawSessionValue() {
        return Odigeo.Utils.parseJson(Odigeo.Session ? Odigeo.Storage.get(sessionKey) : null);
    }

    static get sessionObject() {
        return Odigeo._.extend(this.defaultValues, this.rawSessionValue);
    }

    static set sessionObject(value) {
        Odigeo.Storage.set(sessionKey, JSON.stringify(value));
    }

    static get retry() {
        return this.sessionObject.retry;
    }

    static set retry(value) {
        let obj = this.sessionObject;
        obj.retry = value;
        this.sessionObject = obj;
    }

    static clear() {
        Odigeo.Storage.remove(sessionKey);
    }
};
